import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWindsurfNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.63 13.35a.51.51 0 00-.36-.15h-5C11.92 6.8 10.05 2.4 8.75.32A.43.43 0 008.43.1a.47.47 0 00-.38.07L5.12 2.11a.51.51 0 00-.2.28l-2.25 8a.51.51 0 00.22.57 15.15 15.15 0 006.52 1.71l-.15.55H1.52a.78.78 0 00-.78.78v1a.77.77 0 00.78.77H13.1c2.05 0 2.65-1.29 2.67-2a.47.47 0 00-.14-.42zm-11.89-3.1l2.09-7.41 2.34-1.55a15.14 15.14 0 011.45 10.36 14.92 14.92 0 01-5.88-1.4zm9.36 4.45H1.74v-.5h12.81a1.82 1.82 0 01-1.45.5z"
  }));
});
SvgSportsWindsurfNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsWindsurfNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWindsurfNormalXsmall;